import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ViewProductDetail } from "../../../../redux/services/ProductService/product.Services";
import { ActiveSubCategoryList } from "../../../../redux/services/subCategoriesService/subCategories.Services";
import { successToast, errorToast } from "../../../../Utils/toast";
import ProductProfileCard from "./ProductProfileCard";
import ProductDescriptionCard from "./ProductDescriptionCard";
import ProductSpecificationCard from "./ProductSpecificationCard";
import ProductVariantCard from "./ProductVariantCard";
import ProductInventoryCard from "./ProductInventoryCard";
import ProductTaxCard from "./ProductTaxCard";
import ProductBusinessCard from "./ProductBusinessCard";
import ProductTimelineCard from "./ProductTimelineCard";

import "../../../../assets/css/viewProduct.css";

function ViewProduct() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        fetchProductData();
    }, [id]);

    const fetchProductData = async () => {
        if (!id) {
            errorToast("Product ID is missing");
            navigate("/product-list");
            return;
        }

        try {
            setLoading(true);
            const payload = { id: id };
            const response = await ViewProductDetail(payload);
            
            if (response?.data?.success) {
                const productData = response.data.data;
                setProduct(productData);
            } else {
                errorToast(response?.data?.message || "Product not found");
                navigate("/product-list");
            }
        } catch (error) {
            console.log("Error fetching product:", error);
            errorToast("Failed to load product data");
            navigate(-1);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!product) {
        return (
            <div className="text-center py-5">
                <h4>Product not found</h4>
                <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
                    Go Back
                </button>
            </div>
        );
    }

    return (
        <div className="view-product-container">

            <div className="view-product-header">
                <div className="d-flex justify-content-between align-items-center">
                    {/* <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                            ← Back
                        </button>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/products">Products</a></li>
                                <li className="breadcrumb-item active">{product.product_name}</li>
                            </ol>
                        </nav>
                    </div> */}
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Back
                    </button>
                </div>
            </div>

            <div className="view-product-body">
                <ProductProfileCard product={product} />

                <ProductDescriptionCard product={product} />

                <ProductSpecificationCard product={product} />

                <ProductVariantCard product={product} />
                <ProductInventoryCard product={product} />

                <ProductTaxCard product={product} />

                <ProductBusinessCard product={product} />
                <ProductTimelineCard product={product} />
            </div>

        </div>
    );
}

export default ViewProduct;